{
  "title": "How to Request a New Competition",
  "description": "Submit a competition creation request; once the platform approves it, the competition is created automatically and you become its first organizer admin.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, your request enters the platform's review process; once approved, the competition is created automatically and you automatically become its first admin.",
  "roleNote": "Any signed-in user with a verified email",
  "prerequisites": [
    "You're signed in with a verified email",
    "You have the competition's basic details ready (name, URL slug, organization, contact person)"
  ],
  "pathLabel": "Request a New Competition",
  "steps": [
    {
      "title": "1. Open the request form",
      "description": "Any signed-in user can submit a request — no prior role or status is required."
    },
    {
      "title": "2. Fill in the competition's basic details",
      "description": "Provide the competition name, URL slug, hosting organization, contact person's name and email, a description, and timezone; expected start/end dates and expected participant count are optional."
    },
    {
      "title": "3. Check off the competition's characteristics",
      "description": "Indicate whether judging is required (defaults to yes), whether it's a two-round format, and whether it will collect data from minor students — these choices shape the settings the automated provisioning step will create."
    },
    {
      "title": "4. Submit the request",
      "description": "After submitting, the request status becomes \"Pending Review\"; you can check its status under \"My Requests\", and can still cancel it while review is ongoing."
    },
    {
      "title": "5. Wait for platform review",
      "description": "A platform admin reviews the request — the outcome may be \"Approved\", \"Changes Requested\", or \"Rejected\". Once approved, the system automatically creates the competition (with baseline settings and a first round), and you automatically become its `competition_admin`."
    }
  ],
  "afterward": [
    "The request shows status \"Pending Review\", and you can check its progress at any time",
    "If approved, the system creates the competition automatically and makes you its first organizer admin — no separate role application is needed",
    "If changes are requested, you can revise and resubmit based on the feedback; if rejected, you can see the reason"
  ],
  "nextSteps": "Once your request is approved and the competition is auto-created, see the Platform Administration console or the \"Organizer Manual\" to finish setting up the schedule, categories, registration form, rubric, and more.",
  "faq": [
    {
      "q": "Do I need an existing organizer account before I can request a competition?",
      "a": "No. Any signed-in user with a verified email can submit a request — no prior role is required. Once approved, the system automatically makes you the first admin of the new competition."
    },
    {
      "q": "Can I still edit or cancel the request after submitting it?",
      "a": "You can cancel it while it's still \"Pending Review\" or \"Changes Requested\"; once it's been approved or rejected, the request itself can no longer be changed."
    },
    {
      "q": "Do I create the competition myself after approval?",
      "a": "No. Once approved, the competition is created automatically (Automated Provisioning) — baseline settings and a first round included. You don't take any separate creation step; just sign in as the newly assigned organizer admin and the competition will already be there."
    }
  ]
}
